import type { CookieParseOptions, CookieSerializeOptions } from 'cookie-es'

export type CookieModel = {
  name: string
  value: any
  options?: CookieOptions | undefined
}

export enum IaCookie {
  Bearer = 'bearer',
  Authorization = 'authorization',
  SelectedPharmacy = 'SelectedPharmacy',
  UserData = 'user_data',
  AnonymousUser = 'AnonymousUser',
  Coupon = 'coupon',
  CookieConsent = 'cconsent-v2',
  DeactivatedPharmacyInfo = 'deactivated_pharmacy_info',
  DeliveryStorage = 'DeliveryStorage',
}

type _CookieOptions = Omit<CookieSerializeOptions & CookieParseOptions, 'decode' | 'encode'>

export interface CookieOptions<T = any> extends _CookieOptions {
  decode?(value: string): T
  encode?(value: T): string
  default?: () => T | Ref<T>
  watch?: boolean | 'shallow'
}

export interface CookieRef<T> extends Ref<T> {
}

export type useCookie<T = string | null> = (name: string, _opts?: CookieOptions<T>) => CookieRef<T>
